export default __webpack_public_path__ + "static/media/element_65.fcec1aa7.jpg";